export const getKeyByValue = (object: Record<any, any>, value: any): any => {
  return Object.keys(object).find(key => object[key] === value);
}
